module.exports = __webpack_public_path__ + "static/media/(H)_MG_5949_-_Cia_Termal_Beachewear_-_Moda_Feminina.8902cbb5.jpg";